import React, { useEffect, useState } from 'react'
import { getProfilePictureByUserId, getUserDataById } from '../../../../../utils/requestsUtils/functionsRequests/user/userFunctions'
import "./CardUserBugReport.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { useAppDispatch } from '../../../../../redux/store/store'
import { setTaxInformationTransactionReportReducer } from '../../../../../redux/slices/components/TransactionsBugs/TransactionsBugsSlice'

type CardUserBugReportProps = {
    id: string
}

type UserCardData = {
    name: string
    gimScore: string
    gimmerScore: string
    email: string
}

const CardUserBugReport = ({ id }: CardUserBugReportProps) => {

    const dispatch = useAppDispatch()

    const [user, setUser] = useState<UserCardData | null>(null)
    const [imgUrl, setImgUrl] = useState("")

    useEffect(() => {
      
        const getData = () => {
            getUserDataById(id, { mail: 1, phoneNumber: 1, firstName: 1, lastName: 1, gimmerScore: 1, gimScore: 1, Tax_Information: 1 })
            .then((user: any) => {
                console.log("user", user)
                dispatch( setTaxInformationTransactionReportReducer( Boolean( user.Tax_Information ) ) )
                setUser({
                    name: `${user.firstName} ${user.lastName}`,
                    gimScore: user.gimScore?.toFixed(2) ?? "",
                    gimmerScore: user.gimmerScore?.toFixed(2) ?? "",
                    email: user.mail ?? "",
                })
            }).catch((error) => {  })

            getProfilePictureByUserId(id, "small")
            .then((url) => {
                setImgUrl(url)
            }).catch(() => {
    
            })
        }

        getData()

    }, [])
    

    return (
        <div className="card-user-bug-report center ml-8 border-radius-6">
            <div className="flex">

                <div className="flex">
                    <img 
                        src={imgUrl ?? "/assets/images/profilePic.png"} 
                        className="img-card-user-bug-report circle" 
                        onError={(e) => { (e.target as HTMLImageElement).src = "/assets/images/profilePic.png" }}    
                    />
                    <div className="flex flex-d-column flex-jc-sb ml-16" >
                        <p className="fs-14 fw-500 color-dark-gim">{user?.name}</p>
                        <p className="fs-14 color-text">{user?.email}</p>
                    </div>
                </div>      

            </div>   

        </div>
    )
}

export default React.memo( CardUserBugReport )